module.exports = __webpack_public_path__ + "img/explore-purple.2d4bcd17.svg";